module.exports = __webpack_public_path__ + "static/img/page1-bg-1.dae98f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/page1-bg-1.png
// module id = xuvK
// module chunks = 0